import { Tile } from '@op/opds.opux';
import { type FC, type ReactNode } from 'react';
import styles from './CustomTile.module.scss';

interface Props {
  className?: string;
  children: ReactNode;
}

export const CustomTile: FC<Props> = ({ className, children, ...rest }) => {
  const classes = [styles.tile, className]
    .filter((item) => item !== undefined && item !== '')
    .join(' ');
  return (
    <Tile className={classes} {...rest}>
      {children}
    </Tile>
  );
};
